import {observer} from 'mobx-react';
import {t} from 'shared/core';
import _ from 'lodash';

const ProjectNameCell = observer(({model, uiState}) => {
  const projectName = _.get(_.find(uiState.projects, {id: model.id}), 'name');
  return projectName || <span className='jumbo'>{t('time_tracking.payroll_hours.(No Project)')}</span>;
});

export default ProjectNameCell;
